import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import SmsConversations from './SMSConversations.vue'
import SmsLog from './SMSLog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SMSTab',
  props: {
    newMessageSignal: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { newMessageSignal: number }

// SMS tab of the Messages page: conversations by default; the Every message filter
// toggle swaps in the per-message log, and switching it off comes back here.

const allMessages = ref(false)

// New message always lives on the conversations view
watch(() => props.newMessageSignal, () => { allMessages.value = false })

return { __sfc: true,props, allMessages, SmsConversations, SmsLog }
}

})